export default __webpack_public_path__ + "static/media/le_touquet13.9bcf2a8d.jpg";